// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import Close from "@store/Library/Components/Toolkit/Icons/Close";
import { buttonResetStyles } from "@store/Themes/common/mixins/button";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const tag: Styleguide["tag"] = {
    defaultProps: {
        typographyProps: {
            css: css`
                /* white-space: nowrap; */
                overflow: hidden;
                text-overflow: ellipsis;
            `,
        },
        iconProps: {
            src: Close,
            size: 13,
            color: "inherit",
        },
        css: css`
            min-height: 0;
            align-items: center;
            padding: ${pxToRem(7, 12)};
            margin: 0;
            border-radius: ${pxToRem(4)};
            background-color: ${getColor("common.accent")};
            color: ${getColor("tag.color")}; /* Store Custom Code */

            ${({ theme }) => css`
                font-size: ${theme.design.typography.size.smaller};
                line-height: ${theme.design.typography.lineHeight.small};
            `}

            button {
                ${buttonResetStyles()}
                flex: 0 0 auto;
                width: 1.3em;
                height: 1.3em;
                margin: ${pxToRem(0, -4, 0, 6)};
                color: ${getColor("tag.iconColor")}; /* Store Custom Code */

                &:hover {
                    color: ${getColor("primary.dark")}; /* Store Custom Code */
                }
            }
        `,
    },
};

export default tag;
